import React from 'react';
import SideBar from '../../../shared/templates/CategoryTemplate/category-sidebar';

function PhotosSideBar(props) {
  return (<SideBar {...props} 
    section="photos"
    searchTitle="Search Photos"
    createNewTitle="New Gallery"
    filterList={[
      { name:'keywords', value: 'Enter Keywords' }, 
    ]}
  />);
}

export default PhotosSideBar;